import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import './FavoriteMessage.scss';

const FavoriteMessageLogged = () => (
  <p id="favorites--message" className="favorites--message">
    {trans('favorites.message.top.logged')}
  </p>
);

export default FavoriteMessageLogged;
